import request from '@/utils/request'

const pathSegment = (value) => encodeURIComponent(String(value))
const idempotencyHeaders = (idempotencyKey) => ({ 'Idempotency-Key': idempotencyKey })

export function getLatestMeetingReplayTask(meetingCode) {
  return request({
    url: `/user/meeting/replay/meetings/${pathSegment(meetingCode)}/latest`,
    method: 'get',
  })
}

export function getMeetingReplayTask(taskId) {
  return request({
    url: `/user/meeting/replay/tasks/${pathSegment(taskId)}`,
    method: 'get',
  })
}

export function getRecoverableMeetingReplayCaptures(meetingCode) {
  return request({
    url: `/user/meeting/replay/meetings/${pathSegment(meetingCode)}/recoverable-captures`,
    method: 'get',
  })
}

export function recoverMeetingReplayCapture(meetingCode, captureSessionId, idempotencyKey) {
  return request({
    url: `/user/meeting/replay/meetings/${pathSegment(meetingCode)}/captures/${pathSegment(captureSessionId)}/recover`,
    method: 'post',
    headers: idempotencyHeaders(idempotencyKey),
  })
}

export function createMeetingReplayTask(captureSessionId, idempotencyKey) {
  return request({
    url: `/user/meeting/replay/captures/${pathSegment(captureSessionId)}/generate`,
    method: 'post',
    headers: idempotencyHeaders(idempotencyKey),
  })
}

export function retryMeetingReplayTask(taskId, idempotencyKey) {
  return request({
    url: `/user/meeting/replay/tasks/${pathSegment(taskId)}/retry`,
    method: 'post',
    headers: idempotencyHeaders(idempotencyKey),
  })
}

export function retryMeetingReplayOutput(taskId, outputId, idempotencyKey) {
  return request({
    url: `/user/meeting/replay/tasks/${pathSegment(taskId)}/outputs/${pathSegment(outputId)}/retry`,
    method: 'post',
    headers: idempotencyHeaders(idempotencyKey),
  })
}

export function getMeetingReplayPolicy(meetingCode) {
  return request({
    url: `/user/meeting/replay/policy/${pathSegment(meetingCode)}`,
    method: 'get',
  })
}

export function updateMeetingReplayPolicy(meetingCode, data, idempotencyKey) {
  return request({
    url: `/user/meeting/replay/policy/${pathSegment(meetingCode)}`,
    method: 'put',
    data,
    headers: idempotencyHeaders(idempotencyKey),
  })
}

export function getEnterpriseReplayPolicy(meetingCode) {
  return request({
    url: `/user/meeting/replay/enterprise-policy/${pathSegment(meetingCode)}`,
    method: 'get',
  })
}

export function updateEnterpriseReplayPolicy(meetingCode, data, idempotencyKey) {
  return request({
    url: `/user/meeting/replay/enterprise-policy/${pathSegment(meetingCode)}`,
    method: 'put',
    data,
    headers: idempotencyHeaders(idempotencyKey),
  })
}

const generationPath = (meetingCode) => `/user/meeting/replay/meetings/${pathSegment(meetingCode)}/generation`
export const getReplayInventory = (meetingCode) =>
  request({ url: `${generationPath(meetingCode)}/inventory`, method: 'get' })
export const getReplayVersions = (meetingCode) =>
  request({ url: `${generationPath(meetingCode)}/versions`, method: 'get' })
export const analyzeReplay = (meetingCode, data) =>
  request({ url: `${generationPath(meetingCode)}/analyze`, method: 'post', data })
export const preflightReplay = (meetingCode, data) =>
  request({ url: `${generationPath(meetingCode)}/preflight`, method: 'post', data })
export const confirmReplay = (meetingCode, data, key) =>
  request({ url: `${generationPath(meetingCode)}/confirm`, method: 'post', data, headers: idempotencyHeaders(key) })
export const retryReplayVersion = (meetingCode, id) =>
  request({ url: `${generationPath(meetingCode)}/versions/${pathSegment(id)}/retry`, method: 'post' })

export const regenerateReplayOutput = (meetingCode, id, outputId, key) =>
  request({
    url: `${generationPath(meetingCode)}/versions/${pathSegment(id)}/outputs/${pathSegment(outputId)}/regenerate`,
    method: 'post',
    headers: { 'Idempotency-Key': key },
  })
